import React from 'react';
import styles from './Message.module.css';

import { Photo } from '../Photo/Photo';

const Message = ({ message, rotateSign }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.photoBlock}>
        <Photo message={message} rotateSign={rotateSign} />
      </div>
    </div>
  );
};

export default Message;
